module.exports = __webpack_public_path__ + "static/pattern-bg-725c28363f613734e9e0adc4784d9fc9.jpg";